import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';

/**
 * Container component for the pharmacy page.
 * 
 */
class RequestNewIdCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            showSubmitLoader: false,
            currentMember: null,
            userAddress: null,
            shouldLoadData: true,
            shouldSendData: true,
            showSuccessBanner: false,
            showFailureBanner: false,
            show14DayLimitBanner: false
        };
        this.requestNewIdCard = this.requestNewIdCard.bind(this);
        this.processUserAddress = this.processUserAddress.bind(this);
    }

    componentDidMount() {
        this.componentDidUpdate(this.props);
        logUI("MBHWeb.UI.IDCard.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps) {
        if ((this.props.swhp || this.props.hpIdentity) && this.state.shouldLoadData && !this.props.isFetching) {
            let memberId = this.props.swhp || this.props.hpIdentity.memberUserClaims.memberHccId;
            this.setState({ currentMember: memberId , shouldLoadData: false });
            this.props.getUserProfile(memberId);
        }

        if (this.props.userProfile !== prevProps.userProfile || this.props.userProfileError !== prevProps.userProfileError) {
            this.setState({ showLoader: false });
            this.processUserAddress();
        }

        if ((this.props.submitted !== prevProps.submitted || this.props.submitError !== prevProps.submitError) && !this.state.shouldSendData) {
            if (this.props.submitError !== prevProps.submitError) {
                this.setState({ showSubmitLoader: false, shouldSendData: true, showFailureBanner: true });
            }
            else {
                this.setState({ showSubmitLoader: false});
                if (this.props !== undefined && this.props.submitted !== undefined && this.props.submitted.status === 202) {
                    this.setState({ show14DayLimitBanner: true });
                } else {
                    this.setState({ showSubmitLoader: false, showSuccessBanner: true });
                }
            }
        }
    }

    processUserAddress() {
        if (this.props.userProfile) {
            var mailingAddressString = "";
            var homeAddressString = "";
            this.props.userProfile.Addresses.map((address) => {
                var address1 = address.AddressLine1 == null ? "" : address.AddressLine1;
                var address2 = address.AddressLine2 == null ? "" : " " + address.AddressLine2;
                var address3 = address.AddressLine3 == null ? "" : " " + address.AddressLine3;
                if (address.Type == "Mailing") {
                    mailingAddressString = address1 + address2 + address3 + ", " + address.City + ", " + address.State + " " + address.ZipCode;
                }
                if (address.Type == "Home" && homeAddressString == "") {
                    homeAddressString = address1 + address2 + address3 + ", " + address.City + ", " + address.State + " " + address.ZipCode;
                }
            });
            var addressString = mailingAddressString == "" ? homeAddressString : mailingAddressString;
            this.setState({ userAddress: addressString });
        }
    }

    requestNewIdCard() {
        this.props.submitRequest(this.state.currentMember);
        this.setState({ showSubmitLoader: true, shouldSendData: false, showSuccessBanner: false, showFailureBanner: false, show14DayLimitBanner: false });
    }

    render() {
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="requestidcard-wrapper">
                            {!this.state.showSuccessBanner
                                ?
                                ""
                                :
                                <div className="request-success-banner">
                                    <div className="semi-bold-text request-success-message">
                                        <span className="icon-list-check"></span>Thanks! A copy of your ID card will be sent to your address.
                                    </div>
                                </div>
                            }
                            {!this.state.show14DayLimitBanner
                                ?
                                ""
                                :
                                <div className="request-success-banner">
                                    <div className="semi-bold-text request-success-message">
                                        <span className="icon-list-check"></span>Your ID card was previously requested in the past 14 days.  No additional ID card request may be submitted at this time.
                                    </div>
                                </div>
                            }
                            {!this.state.showFailureBanner
                                ?
                                ""
                                :
                                <div className="request-failure-banner">
                                    <div className="semi-bold-text request-failure-message">
                                        Sorry, we were not able to process your request. Please call customer service to request a new ID card.
                                    </div>
                                </div>
                            }
                            <div className="alt-background requestidcard-container">
                                {this.state.shouldSendData ?
                                    <div className="semi-bold-text request-instruction">
                                        Would you like an ID card sent to your address on file? 
                                    </div>
                                : ""}
                                <div className="card">
                                    <div className="bold-text request-card-header">
                                        Send a copy of my ID card to:
                                    </div>
                                    <div className="card-body">
                                        {this.state.showLoader
                                            ? 
                                            <div className="spinner">
                                                <div className="bounce1" />
                                                <div className="bounce2" />
                                                <div className="bounce3" />
                                            </div>
                                            :
                                            <div className="request-address">
                                                <span className="icon-location request-pin">
                                                </span>
                                                {this.state.userAddress}
                                            </div>
                                        }
                                    </div>
                                </div>
                                {this.state.showSubmitLoader
                                    ?
                                    <div className="spinner">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                    :
                                    !this.state.shouldSendData
                                        ?
                                        ""
                                        :
                                        <div className="row request-button-container">
                                            <div className="col-12 col-sm-6">
                                                <input type="button" className="btn hp-button id-cancel-button" onClick={() => this.props.history.goBack()} value="CANCEL"></input>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <input type="button" className="btn hp-button id-request-button" onClick={() => this.requestNewIdCard()} value="SUBMIT REQUEST" disabled={this.props.isReadOnly}></input>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        userProfile: state.healthPlanServices.userProfile,
        userProfileError: state.healthPlanServices.error,
        submitted: state.healthPlanServices.requestedNewCard,
        submitError: state.healthPlanServices.submitError,
        isFetching: state.healthPlanServices.isFetching,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserProfile: (memberId) => dispatch({ type: types.HP_GET_PROFILE_START, memberId: memberId }),
        submitRequest: (memberId) => dispatch({ type: types.HP_REQUEST_NEW_IDCARD_START, memberId: memberId })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequestNewIdCard));
